import gql from 'graphql-tag';

const IS_DOCUMENT_TEMPLATE_USED = gql`
  query isDocumentTemplateUsed($_id: ID!) {
    isDocumentTemplateUsed(_id: $_id)
  }
`;

export default IS_DOCUMENT_TEMPLATE_USED;
